import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";

import {setStorageItem} from "@/lib/utils";
import useHasPermission from "@/src/hooks/useHasPermission";

import {incidentsService} from "../services";

export default function useIncidentReportTypes() {
  const hasPermission = useHasPermission("incidentreport store");

  const {data, isSuccess, isPending, isError, error} = useQuery({
    queryKey: ["incidentReportTypes", hasPermission],
    queryFn: () => incidentsService.getIncidentReportTypes(),
    enabled: hasPermission,
    retry: false,
    staleTime: Infinity,
    refetchInterval: false,
  });

  useEffect(() => {
    if (isSuccess && data) {
      setStorageItem("incidentReportTypes", data);
    }
  }, [isSuccess, data]);

  return {
    data: hasPermission && isSuccess && data ? data : [],
    isSuccess: hasPermission ? isSuccess : true,
    isPending: hasPermission && isPending,
    isError,
    error,
  };
}
